import { ReactNode } from "react";
import { SunIcon } from "../assets/svgComponents/categoryLabelIcons/sunIcon";
import { MountainIcon } from "../assets/svgComponents/categoryLabelIcons/mountainIcon";
import {ActivityIcon} from "../assets/svgComponents/categoryLabelIcons/activityIcon";
import { PartyIcon } from "../assets/svgComponents/categoryLabelIcons/partyIcon";
import {CityIcon} from "../assets/svgComponents/categoryLabelIcons/cityIcon";
import {WellnessIcon} from "../assets/svgComponents/categoryLabelIcons/wellnessIcon";
import {CultureIcon} from "../assets/svgComponents/categoryLabelIcons/cultureIcon";
import {CampingIcon} from "../assets/svgComponents/categoryLabelIcons/campingIcon";
import {SkiiingIcon} from "../assets/svgComponents/categoryLabelIcons/skiiingIcon";
import {BeachIcon} from "../assets/svgComponents/categoryLabelIcons/beachIcon";

export enum DestinationCategory {
  SUN = "sun",
  ACTIVITIES = "activities",
  MOUNTAINS = "mountains",
  CITY = "city",
  BEACH = "beach",
  PARTY = "party",
  WELLNESS = "wellness",
  CULTURE = "culture",
  CAMPING = "camping",
  WINTER = "winter",
}

export const CategoryLabelMap: Record<DestinationCategory, string> = {
  [DestinationCategory.SUN]: "In die Sonne",
  [DestinationCategory.ACTIVITIES]: "Aktivitäten",
  [DestinationCategory.MOUNTAINS]: "Berge",
  [DestinationCategory.CITY]: "Städtetrip",
  [DestinationCategory.BEACH]: "Strand",
  [DestinationCategory.PARTY]: "Party",
  [DestinationCategory.WELLNESS]: "Wellness",
  [DestinationCategory.CULTURE]: "Kultur",
  [DestinationCategory.CAMPING]: "Camping",
  [DestinationCategory.WINTER]: "Winterurlaub",
};

export const CategoryIconMap: Record<DestinationCategory, ReactNode> = {
  [DestinationCategory.SUN]: <SunIcon />,
  [DestinationCategory.ACTIVITIES]: <ActivityIcon />,
  [DestinationCategory.MOUNTAINS]: <MountainIcon />,
  [DestinationCategory.CITY]: <CityIcon />,
  [DestinationCategory.BEACH]: <BeachIcon />,
  [DestinationCategory.PARTY]: <PartyIcon />,
  [DestinationCategory.WELLNESS]: <WellnessIcon />,
  [DestinationCategory.CULTURE]: <CultureIcon />,
  [DestinationCategory.CAMPING]: <CampingIcon />,
  [DestinationCategory.WINTER]: <SkiiingIcon/>,
};
